"use client";

import VacanciesItem from "@/app/components/vacanties-item";
import { usePathname } from "next/navigation";

interface VacanciesListProps {
    data: Array<{
        Location: string;
        metaData : {
            metaTitle: string;
            slug: string;
        }
    }>;
}

const VacanciesList: React.FC<VacanciesListProps> = ({ data}) => {
    const pathname = usePathname();
    const isEn = pathname.startsWith("/en");

    return (
        <section className="pt-[72px] bg-gray-40 pb-[128px] max-[576px]:pt-[32px] max-[576px]:pb-[64px]">
            <div className="container">
                <div className="grid grid-cols-2 gap-x-6 gap-y-6 mt-[48px] max-[992px]:grid-cols-1 max-[576px]:mt-[0]">
                    {data.map((item: any) => {
                        const meta = item?.metaData;
                        return (
                            <VacanciesItem
                                key={item.id}
                                title={item.title}
                                text={item?.Location || ""}
                                link={`${isEn ? "/en" : ''}/vacancies/${meta?.slug}`}
                            />
                        );
                    })}
                </div>
            </div>
        </section>
    );
}

export default VacanciesList;